import  React, { useEffect, useState } from "react"; import Menubar from "../Menubar"; import {  Container, Row, Col,Form, Button,Modal} from "react-bootstrap"; import { store } from "../../App"; import {ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import * as Yup from "yup";
import { MdOutlinePictureAsPdf } from "react-icons/md"; import autoTable from "jspdf-autotable";
 import { exportToExcel, datetime, generatePdf, commonSelectProps, } from "../utils/commonFunctions";
   import Select from 'react-select'; 
import { Link } from "react-router-dom";
import AlertModal from "../Alert/AlertModal";import useAlert from "../Alert/useAlert";
import MasterService from "../../Services/MasterService";
import { FaRegSave } from "react-icons/fa";
export default function NewsCircular() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [data, setData] = useState([]); const [searchText, setSearch] = useState(""); const [Periodicid, setperiodicId] = useState(); const [Periodicitylist, setPeriodicitylist] = useState();const [Yearlist, setYearlist] = useState(); const [Categorylist, setCategorylist] = useState(); const [mainEnb, setMainenb] = useState(false); const [mandalsName, setmandalsName] = useState(true); const [Deptname, setDeptname] = useState(); const [getEntered, setgetEntered] = useState(true);const[Depts,setDepts]=useState(); const[periodic, setperiodic] = useState(); const [selectedperiodicity, setselectedperiodicity] = useState(); const [enteredMandals, setEnteredMandals] = useState([]);const [notEnteredMandals, setNotEnteredMandals] = useState([]);
const[list,setList]=useState();const[listoptions,setListoptions]=useState();
const[filteredData,setfilteredData]=useState(); let username = localStorage.getItem("username"); 


const validationSchema = Yup.object({
  activity: Yup.string().required("Activity is required"),
  displayOrder: Yup.string().required("Displayorder is required"),

  description: Yup.string() .trim() .required("Description is required"),

  dateOfEntry: Yup.string()
    .required("Date of Entry is required"),

  document: Yup.mixed().when("activity", {
    is: (val) => ["3", "4"].includes(val),
    then: (schema) => schema.required("Document is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

  const formik = useFormik({ initialValues: { activity:"", document:"" ,dateOfEntry:"",description:"",displayOrder:"",date:"",
sno:"",
      editactivity: "",
  editdescription: "",
  editdisplayOrder: "",
  editdate: "",
  editis_enable: false,
  editdocument: null,
  }, 
  validationSchema:validationSchema,
    onSubmit: (values) => { 
      saveData(values)
    } })
     const[showModal,setshowModal] = useState(false); 
const [isChecked, setIsChecked] = useState(false);

const handleClosepop = (index) => {
  console.log("Closing modal for index:", index);

  setshowModal(false);
  setSelectedIndex(null); // ✅ unchecks that checkbox
};


   useEffect(()=>{
    let params={
        userId:username
    }
      
MasterService.getactivities(params).then((res) => {
  if (res?.data?.SDESC) {
    setList(res?.data?.SDESC)
    const options = res.data.SDESC.map(item => ({
      id: item.id,
      value: item.value
    }));

    setListoptions(options);
  }
});

  MasterService.getlistofactivities().then((res)=>{
    if(res.data.SCODE==="01"){
      
setfilteredData(res.data.SDESC)

}
else{setfilteredData([])}
  })

   },[])

const downloadFile = async (fileName) => {
  try {
    const response = await MasterService.getGoPdf(fileName);

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);

    // ✅ Open PDF in new tab
    window.open(url, "_blank");

    // Optional cleanup (after some delay)
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);

  } catch (err) {
    console.error("Download failed:", err);
  }
};


const getData = () => {
  
};
const [fileKey, setFileKey] = useState(Date.now());

function saveData(values) {
  const formData = new FormData();
  formData.append("activity", formik.values.activity);
  formData.append("displayOrder", formik.values.displayOrder);
 
  formData.append("description", formik.values.description);
  formData.append("dateOfEntry", formik.values.dateOfEntry);
  formData.append("buttonType","save" );
  if(formik.values.document){
  formData.append( "document", formik.values.document );
  }
else {
  const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
  formData.append("document", emptyFile);
}
  formData.append("isEnable", true);
  formData.append("userId",localStorage.getItem("username"));
       store.dispatch({ type: "SHOW_SPINNER" });

  MasterService.saveactivities(formData)
    .then((res) => {
       if (res.data && res.data.SCODE === "01") {
 store.dispatch({ type: "HIDE_SPINNER" });

           showAlertMessage(res.data.SDESC,"success",()=>{  MasterService.getlistofactivities().then((res)=>{
setfilteredData(res.data.SDESC)
formik.resetForm({
    values: {
      ...formik.initialValues,
      news: "",
      event: "",
      document: null,
      go: null,

    },
  });
  setFileKey(Date.now()); 
  })})
           formik.setFieldValue("activity","")}
      console.log("Saved successfully", res);
    })
    .catch((err) => {
      console.error("Save failed", err);
    });
}
const [selectedIndex, setSelectedIndex] = useState(null);


// Checkbox handler
const DisbaleCheck = (e, item, index) => {
  if (e.target.checked) {
    // store selected row index
    setSelectedIndex(index);

    // set formik fields from clicked row
    formik.setValues({
      ...formik.values,
      editactivity: item.activity,
      editdescription: item.description,
      editdisplayOrder: item.display_order,
      editdate: item.date_of_entry,
      editis_enable: item.is_enable,
      editdocument: item.document || null,
      sno:item.sno
    });

    // open modal
    setshowModal(true);
  }
};

const UpdateData = async () => {
  if (selectedIndex === null) return;

  const username = localStorage.getItem("username");

  // 🔹 Update only the corresponding index row (UI)
  const updatedData = [...filteredData];

updatedData[selectedIndex] = {
  ...updatedData[selectedIndex],
  activity: formik.values.editactivity,
  description: formik.values.editdescription,
  displayOrder: formik.values.editdisplayOrder,
  date: formik.values.editdate,
  is_enable: formik.values.editis_enable,

  // ✅ IMPORTANT FIX
  document:
    formik.values.editdocument instanceof File
      ? updatedData[selectedIndex].document
      : formik.values.editdocument,

  sno: formik.values.sno,
  userId: username,
};


  setfilteredData(updatedData);

  // 🔹 Backend payload
  const formData = new FormData();
  formData.append("activity", formik.values.editactivity);
  formData.append("displayOrder", formik.values.editdisplayOrder);
  formData.append("description", formik.values.editdescription);
  formData.append("dateOfEntry", formik.values.editdate);
  formData.append("buttonType", "update");
  formData.append("isEnable", formik.values.editis_enable);
  formData.append("Sno", formik.values.sno);
  formData.append("userId", username);

  // ✅ Handle document (new or existing)
  let fileToSend = null;

  if (formik.values.editdocument instanceof File) {
    fileToSend = formik.values.editdocument;
  } else if (updatedData[selectedIndex].document) {
    try {
      const existingFileName = updatedData[selectedIndex].document;
      const response = await fetch(existingFileName);
      const blob = await response.blob();
      fileToSend = new File([blob], existingFileName);

    } catch (err) {
      console.error("Failed to fetch existing file", err);
    }
  }

  if (fileToSend) {
    formData.append("document", fileToSend);
  }

  // 🔹 Call API
  store.dispatch({ type: "SHOW_SPINNER" });

  MasterService.saveactivities(formData)
    .then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });
      if (res.data?.SCODE === "01") {
        showAlertMessage(res.data.SDESC, "success", () => {
          MasterService.getlistofactivities().then((res) => {
            setfilteredData(res.data.SDESC);
          });
        });
        setshowModal(false);
        setSelectedIndex(null);
      }
    })
    .catch((err) => {
      store.dispatch({ type: "HIDE_SPINNER" });
      console.error("Update failed", err);
    });
};

  const handleKeyDown = (e) => { if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); } }

    return (
        <>


                                <Menubar />
          <Container className='map-header1' fluid > <div className='sa-title'> <h2> Activities <span>   </span></h2> </div> </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
              <FormikProvider value={formik} >
                        <Form onSubmit={formik.handleSubmit}>
         
 <div className='p-4 mt-2'>
              {/* <Row>
             
                                          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> Activity List</label>
                                                           <Select {...commonSelectProps({ name: "activity", options: list, value: formik.values.activity, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled:false, extraOnChange: (option) => { getData(option ? option.id : "")   } })} />
                                         
                                                               
                                                              </Col> 
                                                          
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                                                <h5>Date</h5>
                                                <Field className="mb-3 form-control" type="date" name="date" controlId="formBasicEmail" style={{ fontWeight: "bold" }}/>
                              
                                              </Col>
                                   
                 <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                                                <h5>Display Order</h5>
                                                <Field className="mb-3 form-control" type="text" name="display" controlId="formBasicEmail" style={{ fontWeight: "bold" }}/>
                              
                                              </Col>
                                    {formik.values.activity==="1"&&
                                              <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                                                <h5>News</h5>
                                                <Field className="mb-3 form-control" as="textArea" name="news" controlId="formBasicEmail" style={{ fontWeight: "bold" }}/>
                              
                                              </Col>}
{formik.values.activity==="2"&&
                                                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                                                <h5>Event</h5>
                                                <Field className="mb-3 form-control" as="textArea" name="event" controlId="formBasicEmail" style={{ fontWeight: "bold" }}/>
                              
                                              </Col>}{formik.values.activity==="3"&&
                                               <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select' >
                                                <h5>Circular</h5>
                              
<input
  className="mb-3 form-control"
  type="file"
  name="circular"
  accept=".pdf"
  onChange={(e) => formik.setFieldValue("circular", e.target.files[0])} // store the file in formik
  style={{ fontWeight: "bold" }}
/>

                                              </Col>}
                                              {formik.values.activity==="4"&&
  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                                                <h5>Go's</h5>
                              <input
  className="mb-3 form-control"
  type="file"
  name="go"
   accept=".pdf"
  onChange={(e) => formik.setFieldValue("go", e.target.files[0])} // store the file in formik
  style={{ fontWeight: "bold" }}
/>
                                              </Col>}
                                              {formik.values.activity&&
                                                         <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} >
                                                                 <div className="bottom-buttons mt-2 ">
                                                    <Button
                                                      variant=""
                                                      size="sm"
                                                      className="save-btn me-4"
                                                      onClick={saveData}
                                                    >
                                                      Save <FaRegSave className="ms-1 s-icon" />
                                                    </Button></div>
          </Col>}
                                              </Row>
                                */}
        
        <Row>
  {/* Activity */}
  <Col md={3}>
    <label className="mb-1 fw-bold">Activity List</label>
    <Select
      {...commonSelectProps({
        name: "activity",
        options: list,
        value: formik.values.activity,
        optionValueKey: "id",
        optionLabelKey: "value",
        formik,
        isDisabled: false,
        extraOnChange: (option) => getData(option?.id || ""),
      })}
    />
<ErrorMessage name="activity"  className="text-error" component="div" />

  </Col>

  {/* Date */}
  <Col md={3}>
    <label className="fw-bold">Date</label>
    <Field
  type="date"
  name="dateOfEntry"
  className="mb-3 form-control"
  max={new Date().toISOString().split("T")[0]}
/>
<ErrorMessage name="dateOfEntry"  className="text-error" component="div" />

  </Col>

  {/* Display Order */}
  <Col md={3}>
    <label className="fw-bold">Display Order</label>
    <Field
      type="text"
      name="displayOrder"
      className="mb-3 form-control"
    />
<ErrorMessage name="displayOrder"  className="text-error" component="div" />

  </Col>

 
  <Col md={3}>
    <label className="fw-bold">Upload File</label>
    <input
      key={fileKey}
      type="file"
       name="document"
      accept=".pdf"
      className="mb-3 form-control"
      onChange={(e) =>
        formik.setFieldValue("document", e.target.files[0])
      }
    />
<ErrorMessage name="document"  className="text-error" component="div" />

  </Col>
<Col md={3} lg={5} >
  <label className="fw-bold">Description</label>
  <Field
    as="textarea"
    name="description"
    className="mb-6 form-control w-100" 
    rows={6} 
    style={{ minHeight: "54px" }}                          
  />

<ErrorMessage name="description"  className="text-error" component="div" />

  </Col>
    <Col md={3}>
          <div className="bottom-buttons mt-2 ">
                                                    <Button
                                                      variant=""
                                                      size="sm"
                                                      className="save-btn me-4"
                                                      type="submit"
                                                    >
                                                      Save <FaRegSave className="ms-1 s-icon" />
                                                    </Button></div>
  </Col>
</Row>

        </div> 
{/* <div id="table-scroll" className="table-scroll table-wrap"> */}
                                                      <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered sticky-table">

  <thead>
    <tr>

      <th style={{color:"black"}}>Activity</th>
      <th style={{color:"black"}}>Display Order</th>
      <th style={{color:"black",width:"10%"}}>Date of Entry </th>
      <th style={{color:"black"}} className="indicator-column">Description</th>
      <th style={{color:"black"}}  className="indicator-column">Document</th>
      <th style={{color:"black"}}>Status</th>
      <th style={{color:"black"}}>Edit</th>
    </tr>
  </thead>
  <tbody>
    {filteredData?.map((item, index) => (
      <tr key={index}>
        <td>{item.activity_name}</td>
        <td style={{textAlign:"right"}} >{item.display_order}</td>
        <td style={{width:"10%"}}>{item.date_of_entry}</td>
        <td  className="indicator-column">{item.description||"-"}</td>
       <td  className="indicator-column">
  {item.document ? (
    <Link
     style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }}
      onClick={() => downloadFile(item.document)}
    >
    { item.document}
    </Link>
  ) : (
    "No File"
  )}
</td>

        <td>{item.is_enable ? "Active" : "Inactive"}</td>
        {item.is_enable===true? 
       <td style={{ textAlign: "center" }}> <input type="checkbox"    checked={selectedIndex === index} // or your state
  onChange={(e) => {DisbaleCheck(e,item, index);setIsChecked(e.target.checked)}} /> </td>:<td></td>}
      </tr>
    ))}
  </tbody>
</table>

            
                            {/* </div> */}
{/* <Modal
  fade={false}
  className="newmodal"
  centered
  show={showModal}
  backdrop="static"
  keyboard={false}
  onHide={() => handleClosepop(selectedIndex)}  // ✅ pass index
>

                  <Modal.Header> <Modal.Title></Modal.Title> <span role="button" tabIndex={0} onClick={handleClosepop} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClosepop(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = 'red')} onMouseLeave={(e) => (e.currentTarget.style.color = 'white')} style={{ fontSize: '30px', cursor: 'pointer' }} className="me-1" > &#215; </span> </Modal.Header>
            
                  <Modal.Body className="p-3 d-flex flex-column justify-content-center align-items-center" onKeyDown={handleKeyDown} > <div className="text-center"> <img src="images/question.gif" style={{ width: '70px', marginBottom: '10px' }} alt="Warning Icon" /> <p className="fw-bold" style={{ fontSize: '17px' }}> Are you sure you want to Disable?  Once Submitted no further changes will be allowed. </p> </div> </Modal.Body>
 
 <Modal.Footer>
  <button
    type="button"
    className="conform"
    onClick={() => UpdateData(selectedIndex)}
  >
    Yes
  </button>

  <button
    type="button"
    className="cancel"
    onClick={handleClosepop}
  >
    No
  </button>
</Modal.Footer>

                </Modal>  */}

                <Modal
  fade={false}
  className="newmodal"
  centered
  show={showModal}
  backdrop="static"
  keyboard={false}
  size="xl"
  onHide={() => handleClosepop(selectedIndex)}  // ✅ pass index
>

                  <Modal.Header> <Modal.Title></Modal.Title> <span role="button" tabIndex={0} onClick={handleClosepop} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClosepop(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = 'red')} onMouseLeave={(e) => (e.currentTarget.style.color = 'white')} style={{ fontSize: '30px', cursor: 'pointer' }} className="me-1" > &#215; </span> </Modal.Header>
            
                  <Modal.Body className="p-3 d-flex flex-column justify-content-center align-items-center"  >
                         <Row>
  {/* Activity */}
   <Col md={3}>
    <label className="mb-1 fw-bold">Activity List</label>
   <Field
  as="select"
  name="editactivity"
  className="mb-3 form-control"
>

  {listoptions?.map((opt) => (
    <option key={opt.id} value={opt.id}>
      {opt.value}
    </option>
  ))}
</Field>

 
  </Col>

  {/* Date */}
  <Col md={3}>
    <label className="fw-bold">Date</label>
    <Field
  type="date"
  name="editdate"
  className="mb-3 form-control"
  max={new Date().toISOString().split("T")[0]}
/>

  </Col>

  {/* Display Order */}
  <Col md={3}>
    <label className="fw-bold">Display Order</label>
    <Field
      type="text"
      name="editdisplayOrder"
      className="mb-3 form-control"
    />
  </Col>

  {/* Description */}

  {/* File Upload */}
  <Col md={3}>
    <label className="fw-bold">Upload File</label>
    <input
      type="file"
       name="editdocument"
      accept=".pdf"
      className="mb-3 form-control"
      onChange={(e) =>
        formik.setFieldValue("editdocument", e.target.files[0])
      }
    />
  </Col>
<Col md={3} lg={5} >
  <label className="fw-bold">Description</label>
  <Field
    as="textarea"
    name="editdescription"
    className="mb-6 form-control w-100" 
    rows={6} 
    style={{ minHeight: "54px" }}                          
  />
  </Col>
  <Col md={3}>
    


<div className="form-check mt-4" >
  <input
    type="checkbox"
    id="editis_enable"
    className="form-check-input"
    checked={!formik.values.editis_enable} // YES = false, NO = true
    onChange={(e) => formik.setFieldValue("editis_enable", !e.target.checked)}
  />
   <label className="fw-bold">Disable</label>

  </div></Col>
   
  
</Row>
                    
                     </Modal.Body>
 
 <Modal.Footer>
  <button
    type="button"
    className="conform"
    onClick={() => UpdateData()}
  >
    Update
  </button>

</Modal.Footer>

                </Modal> 
</Form> </FormikProvider> </Container> <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> </> ); }
 
 